export default __webpack_public_path__ + "images/cbbe234474c9d94f729a9eadeb499d8d.png";